export default __webpack_public_path__ + "static/media/pic (1).0291eef3.jpg";